import { createContext, useContext, type ReactNode } from 'react';
import { useMoldedUI } from '../hooks/useMoldedUI';
import type { VerticalManifest } from '../types/vertical';

interface VerticalContextType {
    molded: VerticalManifest;
    activeOrgId: string | null;
    orgCreatedAt: string | null;
    loading: boolean;
    error: string | null;
}

const VerticalContext = createContext<VerticalContextType | undefined>(undefined);

export const VerticalProvider = ({ children }: { children: ReactNode }) => {
    const { molded, activeOrgId, orgCreatedAt, loading, error } = useMoldedUI();

    return (
        <VerticalContext.Provider value={{ molded, activeOrgId, orgCreatedAt, loading, error }}>
            {children}
        </VerticalContext.Provider>
    );
};

export const useVertical = () => {
    const context = useContext(VerticalContext);
    if (context === undefined) {
        throw new Error('useVertical must be used within a VerticalProvider');
    }
    return context;
};
